module.exports = __webpack_public_path__ + "media/img/course-2-3227cac0d3700b24239e35b2f6f7a197.png";